import { useContext, useEffect, useMemo, useState } from 'react';
import { getDeviceSize, onDeviceSizeChange } from '../lib/device.js';
import { isDataUrl, isSafeUrl } from '../lib/index.js';
import { getRequestContext } from '../ssr-bridge/index.js';
import { isBrowser } from '../utils/index.js';
import { microfrontendContext } from './context.js';
export function useMfProps() {
    const mfContext = useContext(microfrontendContext);
    return useMemo(() => {
        if (!Object.keys(mfContext.context).length)
            throw '"context" is not valid. Please provide context using <Microfrontend/>.';
        return mfContext;
    }, [mfContext]);
}
export function useMfResource() {
    const { mfServer, mfId } = useMfProps();
    const getResourceUrl = (path) => {
        if (isDataUrl(path))
            return path;
        if (!isSafeUrl(path))
            return '';
        return new URL(process.env.NODE_ENV === 'development' ? path : `/${mfId}${path}`, mfServer).href;
    };
    return {
        getResourceUrl,
    };
}
export function useClientResource() {
    const getResourceUrl = (path) => {
        if (!isSafeUrl(path))
            return '';
        return path;
    };
    return {
        getResourceUrl,
    };
}
/**
 * Use the device info in the current component
 */
export function useDevice() {
    const [deviceSize, setDeviceSize] = useState(getInitialSize);
    const isMobile = deviceSize === 'SMALL' || deviceSize === 'MEDIUM';
    const isPhone = deviceSize === 'SMALL';
    useEffect(() => {
        setDeviceSize(getDeviceSize());
        return onDeviceSizeChange(setDeviceSize);
    }, []);
    return {
        deviceSize,
        isMobile,
        isPhone,
    };
}
function getInitialSize() {
    const userAgent = isBrowser() ? navigator.userAgent : getRequestContext()?.headers['user-agent'] || '';
    // check if tablet
    const tabletAgent = /(ipad| sm-t| gt-p| gt-n|wt19m-fi|nexus 7| silk\/|kindle| nook )/i;
    if (tabletAgent.test(userAgent)) {
        return 'MEDIUM';
    }
    // check if mobile
    const mobileAgent = /(android|iphone|mobile|opera mini|windows phone|blackberry|netfront)/i;
    if (mobileAgent.test(userAgent)) {
        return 'SMALL';
    }
    // others
    return 'LARGE';
}
//# sourceMappingURL=hooks.js.map